import { getDayOfWeek, isFirstDayOfWeek } from '../../bs-moment/utils/date-getters';
import { changeDate } from './date-utils';
export function getStartingDayOfCalendar(date, options) {
    if (isFirstDayOfWeek(date, options.firstDayOfWeek)) {
        return date;
    }
    var weekDay = getDayOfWeek(date);
    return changeDate(date, { day: -weekDay });
}
//# sourceMappingURL=bs-calendar-utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker/utils/bs-calendar-utils.js
// module id = 875
// module chunks = 103